import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import XBadge from '../lib/XBadge';
import { getRandomElement } from '../common/Helpers';
import { CAMPAIGN_LOCATION_KEY } from "../common/Constants";
import campaignLogo from '../../assets/images/moonpay.32.png';
// import campaignLogo from '../../assets/images/icons/fxrp.64.webp';

const excludedCountries = [
  "KP",
];

/** Moonpay */
const adVariations = [
  {
    label: <>Buy now on Moonpay &rarr;</>,
    title: <>Buy XRP with 50% off MoonPay Fees, for your first 5 transactions. T&C's apply, new users only and not for UK users.</>,
    href: "https://api.xrpscan.com/api/v1/campaign/moonpaytext",
  },
];

/** Flare */
// const adVariations = [
//   {
//     label: <>Get started &rarr;</>,
//     title: <>XRP enters DeFi with FXRP — now live on Flare. Lend, borrow, provide liquidity, and soon, stake.</>,
//     href: "https://api.xrpscan.com/api/v1/campaign/flaretext",
//   },
// ];

const adVariation = getRandomElement(adVariations);

const TextAd = (props) => {
  const [location] = useState(sessionStorage.getItem(CAMPAIGN_LOCATION_KEY));

  if (!location || excludedCountries.includes(location)) {
    return <></>
  }

  return (
    <div>
      <Card className="shadow-sm" border="info">
        <Card.Body>
          <XBadge variant="light"><small>Sponsored:</small></XBadge>
          <Image alt="Moonpay logo" src={campaignLogo} height="24" className="ml-1" />
          <span className="ml-1">{adVariation.title}</span>
          <span className="ml-2"><a href={adVariation.href} target="_blank" rel="noopener noreferrer">{adVariation.label}</a></span>
        </Card.Body>
      </Card>
    </div>
  );
}

TextAd.propTypes = {
  location: PropTypes.string,
}

export default TextAd;
